// basesAnalyzePending.js — pending analyze scope helpers for Ai UI

export function addPendingAnalyze(previous, messageKey, threadRootKey = '') {
  const next = new Map(previous);
  next.set(String(messageKey || '').trim(), {
    threadRootKey: String(threadRootKey || '').trim(),
  });
  return next;
}

export function removePendingAnalyze(previous, messageKey) {
  const next = new Map(previous);
  next.delete(String(messageKey || '').trim());
  return next;
}

export function countPendingAnalyzes(pendingByMessageKey, { threadRootKey } = {}) {
  const entries = pendingByMessageKey instanceof Map
    ? pendingByMessageKey.values()
    : [];

  if (threadRootKey === undefined) {
    return pendingByMessageKey instanceof Map ? pendingByMessageKey.size : 0;
  }

  const targetThreadRootKey = String(threadRootKey || '').trim();
  let count = 0;

  for (const entry of entries) {
    const entryThreadRootKey = String(entry?.threadRootKey || '').trim();
    if (entryThreadRootKey === targetThreadRootKey) {
      count += 1;
    }
  }

  return count;
}
